// extracted by mini-css-extract-plugin
export default {"Previous":"PreviousButton_Previous__PjAYM"};